<template>
  <div class="candidates-container text-left">
    <div class="candidate-pool text-left">
      <div class="mb-1 text-body-1 text-textLight">
        Estimated Candidate Pool
      </div>
      <div class="mb-1 d-flex">
        <h5>
          {{ specificityLabel }}
        </h5>
        <EstimatedCandidatesIcon
          v-if="!hideTooltipIcon"
          class="ml-auto estimated-candidates-icon"
          :specificity-label="specificityLabel"
        />
      </div>
      <div class="mb-1">
        <span class="text-body-1 text-textLight">
          Similar Global Jobs:
        </span>
        <h5>{{ globalSimilar }}</h5>
      </div>
      <div
        v-if="localSimilar !== null"
        class="mb-1"
      >
        <p>Similar Local Jobs: </p><h5>{{ localSimilar }}</h5>
      </div>
      <div class="mt-3 read-more-link">
        <a
          href="https://help.datapeople.io/article/235-candidate-pool-size-estimator"
          target="_blank"
          rel="noopener noreferrer"
        >Read more here</a>
      </div>
    </div>
  </div>
</template>
<script>
import EstimatedCandidatesIcon from '@/components/editor/EstimatedCandidatesIcon.vue';

/* eslint-disable vue/require-prop-types */
export default {
  components: {
    EstimatedCandidatesIcon,
  },
  props: [
    'specificityLabel',
    'globalSimilar',
    'localSimilar',
    'hideTooltipIcon',
  ],
};
</script>
<style scoped lang="less">
.candidates-container {
  cursor: default;
  line-height: 20px;
  width: 320px;
  border-radius: 8px;
}

p {
  display: inline;
}
h5 {
  display: inline;
}

.read-more-link a {
  color: @text-brand !important;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.estimated-candidates-icon {
  max-width: 45px;
}
</style>
